module.exports = __webpack_public_path__ + "static/photoFritz-7a450f7912df16d8cfb95442c8957319.png";